import http from "../../http-common";
/* eslint-disable */
class SeminatService {
  seminat() {
    return http.get("/seminat", {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("description", data.description);

    if (data.poster_url != null) bodyFormData.append("photo", data.poster_url);

    return http.post("/seminat", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("description", data.description);
    if (data.poster_url != null) bodyFormData.append("photo", data.poster_url);

    return http.put(`/seminat/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new SeminatService();
